import { GLOBAL_UPDATE_STATE,SET_WIZARD_VALUE} from "../actionTypes";

const initialState = {branding:{},form:{nineToKnowContent:{},user:{},client:{},scenario:{employment:{}}}};

export default function(state = initialState, action) {
  switch (action.type) {
    case GLOBAL_UPDATE_STATE:{
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_WIZARD_VALUE: {
        // let form = state.form;
        // let {key,value,currentStep,stepsOpened} = action.payload;
        // form[key] = {...form[key],...value};
        // form.currentStep = currentStep;
        // form.stepsOpened = stepsOpened;
        state.form = action.payload;  
      return state;
    }
    default:
      return state;
  }
}
